// extracted by mini-css-extract-plugin
export default {"root":"Home_root__oYy8a","textCenter":"Home_textCenter__sMHcE","counters":"Home_counters__iEcqu","imageWr":"Home_imageWr__TTeh3"};